"use strict";

/* Controllers */

_BannerFlowApp.controller(
    "ConfirmLockDialogController",
    function ConfirmLockDialogController($scope, $rootScope) {
        $scope.confirmLockModel = {
            hasFeed:
                _.filter($scope.ngDialogData.items, function (i) {
                    return i.isFeeded;
                }).length > 0,
            locked: !$scope.ngDialogData.lock,
            type: $scope.ngDialogData.type,
            multiple: $scope.ngDialogData.items.length > 1,
            typeName: ""
        };

        switch ($scope.confirmLockModel.type) {
            case $rootScope.OBJECT_TYPE_FEED:
                $scope.confirmLockModel.typeName = "feed";
                $scope.confirmLockModel.typeNamePlural = "feeds";
                break;
            case $rootScope.OBJECT_TYPE_LANDINGPAGE:
                $scope.confirmLockModel.typeName = "landing page";
                $scope.confirmLockModel.typeNamePlural = "landing pages";
                break;
        }

        $scope.lock = function (lockChildren) {
            $scope.confirmLockModel.loading = true;

            var data = {
                lockDependencies: lockChildren,
                items: $scope.ngDialogData.items,
                lock: $scope.ngDialogData.lock
            };

            $scope.ngDialogData.resource.lock(data, function () {
                $scope.closeThisDialog("reload");
            });
        };
    }
);
